import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "qcode-sign-container" }
const _hoisted_2 = {
  key: 0,
  class: "sign-success"
}
const _hoisted_3 = { class: "sign-success-title" }
const _hoisted_4 = { class: "sign_time" }
const _hoisted_5 = {
  key: 1,
  class: "sign-late"
}
const _hoisted_6 = { class: "sign-late-title" }
const _hoisted_7 = {
  key: 2,
  class: "no-access"
}
const _hoisted_8 = { class: "no-access-title" }
const _hoisted_9 = {
  key: 3,
  class: "error-page"
}
const _hoisted_10 = { class: "error-title" }

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getTrainingSignScan } from '@/api/requests/TrainingRequests'
import { showToast } from 'vant'
import { useI18n } from 'vue-i18n'

interface SignInParams {
  signInId: string | null
  qrcode: string | null
}

// 初始化函数

export default /*@__PURE__*/_defineComponent({
  __name: 'qrcodeSign',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

// 响应式数据
const errorMessage = ref('')
const noAccess = ref(false)
const showError = ref(false)
const signSuccess = ref(false)
const signInTime = ref('')
const signLate = ref(false)

const init = async (): Promise<void> => {
  try {
    const jumpId = route.query.jumpId as string | null
    const qrcode = route.query.qrcode as string | null

    const params: SignInParams = {
      signInId: jumpId,
      qrcode
    }

    const { code, data, msg } = await getTrainingSignScan(params)

    if (code === 1) {
      const signInStatus = data.signInRecord.signInStatus

      if (signInStatus === 200) {
        // 显示签到成功页面
        signInTime.value = data.signInRecord.signInTime
        signSuccess.value = true
      } else if (signInStatus === 300) {
        // 显示签到已结束页面
        signLate.value = true
      }
    } else if (code === 4001542 || code === 4001543) {
      // 无权限
      noAccess.value = true
    } else if (code === 14280) {
      showToast(msg)
      localStorage.removeItem('sandsTalkToken')
    } else {
      // 其他错误 - 显示错误页面
      errorMessage.value = msg || ''
      showError.value = true
    }
  } catch (error) {
    console.error('签到请求失败:', error)
    errorMessage.value = t('app_network_error')
    showError.value = true
  }
}

onMounted(() => {
  const sandsTalkToken = localStorage.getItem('sandsTalkToken')
  if (!sandsTalkToken) {
    const currentUrl = encodeURIComponent(window.location.href)
    router.push({
      path: '/enterpriseLogin',
      query: {
        redirect: currentUrl
      }
    })
  } else {
    init()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (signSuccess.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sign-success-icon" }, null, -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('signin_succ')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('signin_time')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(signInTime.value), 1)
          ])
        ]))
      : (signLate.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "sign-late-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('checkin_ended')), 1)
          ]))
        : (noAccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "no-access-icon" }, null, -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('no_scan_permission')), 1)
            ]))
          : (showError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "error-icon" }, null, -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(errorMessage.value), 1)
              ]))
            : _createCommentVNode("", true)
  ]))
}
}

})